export * from './inMemoryGenericTable';
